<app-auth-shell>
  @if (pending) {
    <span class="af-badge" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4.5" y="10.5" width="15" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/><path d="M12 14.5v2.5"/></svg>
    </span>
    <div class="af-head">
      <h1>Choose a new password</h1>
      <p>
        @if (pending.first_name) { Welcome back, {{ pending.first_name }}. }
        WorldTumbler has a new, more secure sign-in. Please choose a new password to continue. You'll use it from now on.
      </p>
    </div>

    @if (error) {
      <div class="af-alert af-alert--error" role="alert"><p>{{ error }}</p></div>
    }

    <form class="af-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <input type="email" class="visually-hidden" [value]="pending.email" autocomplete="username" tabindex="-1" aria-hidden="true" readonly />
      <app-password-field [control]="form.controls.password" label="New password" inputId="np-password"
        autocomplete="new-password" [showStrength]="true" [serverError]="passwordError"></app-password-field>
      <app-password-field [control]="form.controls.confirm" label="Confirm new password" inputId="np-confirm"
        autocomplete="new-password"></app-password-field>
      @if (form.controls.confirm.errors?.['mismatch'] && form.controls.confirm.touched) {
        <p class="af-error af-mismatch">The passwords don't match.</p>
      }
      <button type="submit" class="af-btn af-btn--primary" [disabled]="busy">
        @if (busy) { <span class="af-spinner" aria-hidden="true"></span> Saving… } @else { Save and continue }
      </button>
    </form>

    <p class="af-foot">Not you? <button type="button" class="af-link" (click)="cancel()">Use another account</button></p>
  }
</app-auth-shell>
